export const Heading = (props: {content: string}) => {
    const {content} = props;

    return <h2>{content}</h2>;
};
